import { styled as d, css as u } from "styled-components";
import { useState as g, useCallback as p, useEffect as h } from "react";
const S = (t) => !!t && !!t && /^[\w\-+.]+@([\w-]+\.)+[\w-]{2,3}$/.test(t), $ = (t) => typeof t == "string" && !isNaN(Number.parseInt(t)), I = (t) => {
  if (t == null || t === "") return !1;
  const n = Number(t);
  return typeof t == "string" && n >= 0 && Number.isInteger(n);
}, C = (t, { min: n, h: e, d: r, w: c }) => {
  if (t < 0)
    throw new Error("Received time value was less than zero.");
  const i = (o, l) => Math.floor(l ? o % l : o), s = 60, f = 24, w = 7, a = /* @__PURE__ */ new Map();
  if (n) {
    let o = null;
    e ? o = s : r ? o = s * f : c && (o = s * f * w), a.set("min", i(t, o));
  }
  if (e) {
    let o = null;
    const l = t / s;
    r ? o = f : c && (o = f * w), a.set("h", i(l, o));
  }
  if (r) {
    const o = c ? w : null, l = t / s / f;
    a.set("d", i(l, o));
  }
  if (c) {
    const l = t / s / f / w;
    a.set("w", i(l, null));
  }
  return a.size === 0 && a.set("min", i(t, null)), Object.fromEntries(a);
}, L = (t, n) => typeof t == "number" ? `${t}px` : t || n, y = d.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  min-height: 16px;
  font-size: 13px;
`, k = d.div`
  display: flex;
`, T = d.p`
  font-weight: 700;
  font-size: 10px;
  line-height: 1;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  white-space: nowrap;
  margin: 0;
`, v = d.div`
  display: flex;
`, A = d(y)`
  margin-bottom: 0;
  margin-top: 8px;
  min-height: 1em;
  font-size: 16px;
`, M = d.div`
  display: flex;
  align-items: center;
`, R = d.p`
  font-size: 13px;
  line-height: 1;
  letter-spacing: 0.1px;
  color: ${({ theme: t }) => t.colors.red50};
`, O = 8, j = u`
  font-family: inherit;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;

  ${({ theme: { down: t } }) => t("tablet")} {
    font-size: 14px;
  }
`, m = "0px 1px 8px rgba(0, 0, 0, 0.17)", b = "0px 4px 20px rgba(0, 0, 0, 0.07)", x = "0px 4px 28px rgba(0, 0, 0, 0.14)", V = u`
  -webkit-filter: blur(0);
  will-change: filter;
  filter: drop-shadow(${m});
`, W = u`
  -webkit-filter: blur(0);
  will-change: filter;
  filter: drop-shadow(${b});
`, B = u`
  -webkit-filter: blur(0);
  will-change: filter;
  filter: drop-shadow(${x});
`, F = u`
  box-shadow: ${m};
  -webkit-filter: blur(0);
  filter: blur(0);
`, H = u`
  box-shadow: ${b};
  -webkit-filter: blur(0);
  filter: blur(0);
`, N = u`
  box-shadow: ${x};
  -webkit-filter: blur(0);
  filter: blur(0);
`, P = (t = !1) => {
  const [n, e] = g(t), r = p(
    () => e((s) => !s),
    [e]
  ), c = p(() => e(!1), [e]), i = p(() => e(!0), [e]);
  return { isToggled: n, toggle: r, toggleFalse: c, toggleTrue: i };
}, Z = (t, n) => {
  h(() => {
    const e = (r) => {
      Array.isArray(t) && t.some(
        (i) => !i.current || i.current.contains((r == null ? void 0 : r.target) || null)
      ) || !Array.isArray(t) && (!t.current || t.current.contains((r == null ? void 0 : r.target) || null)) || n(r);
    };
    return document.addEventListener("mousedown", e), document.addEventListener("touchstart", e), () => {
      document.removeEventListener("mousedown", e), document.removeEventListener("touchstart", e);
    };
  }, [t, n]);
}, q = () => {
  const [t, n] = g({
    width: 0,
    height: 0
  });
  return h(() => {
    const e = () => {
      n({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };
    return e(), window.addEventListener("resize", e), () => {
      window.removeEventListener("resize", e);
    };
  }, []), t;
}, G = () => {
  const [t, n] = g(!0);
  return h(() => {
    n(!1);
  }, []), t;
};
export {
  y as ControlsContainer,
  R as ErrorText,
  A as InfoContainer,
  T as Label,
  k as LabelContainer,
  M as MessageContainer,
  v as OptionContainer,
  F as boxShadow1,
  H as boxShadow2,
  N as boxShadow3,
  j as fontCss,
  S as isEmailValid,
  $ as isNumberValid,
  I as isPositiveIntegerOrZero,
  O as padding,
  C as parseMinutes,
  L as parseWidth,
  V as shadowElevation1,
  W as shadowElevation2,
  B as shadowElevation3,
  Z as useOutside,
  G as useSSR,
  P as useToggle,
  q as useWindowSize
};
